<template>
  <div id="invigilate_warning">
    <h1>you are about to see ...</h1>
    <button @click="confirm">OK</button>
  </div>
</template>
<script>
export default {
  methods: {
    confirm() {
      this.$store.dispatch('confirmInvigilateWarning')
    },
  },
}
</script>
